import { render } from "./AllServices.vue?vue&type=template&id=1a343e62&scoped=true"
import script from "./AllServices.vue?vue&type=script&lang=js"
export * from "./AllServices.vue?vue&type=script&lang=js"

import "./AllServices.vue?vue&type=style&index=0&id=1a343e62&scoped=true&lang=css"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a343e62"]])

export default __exports__